import { render, staticRenderFns } from "./echart2.vue?vue&type=template&id=44f90b73"
import script from "./echart2.vue?vue&type=script&lang=js"
export * from "./echart2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports